module.exports = __webpack_public_path__ + "images/quingo_small6ac1ae2955f713c586f7e6f26ac519b8.png";